import { render, staticRenderFns } from "./TicketRateIcon.vue?vue&type=template&id=0fdd4609&scoped=true&lang=pug"
import script from "./TicketRateIcon.vue?vue&type=script&lang=js"
export * from "./TicketRateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd4609",
  null
  
)

export default component.exports